module.exports = __webpack_public_path__ + "media/start_page11.f7bb8a30.mp3";